module.exports = __webpack_public_path__ + "media/images/lavita_banner/banner__sidebar--en-2e95eaa02e2291add41e2209a6987b44.jpg";